<mat-accordion>
  <mat-expansion-panel
    *ngFor="let item of data; let i = index"
    [expanded]="currentSelectedIndex === i"
    [hideToggle]="!item.content"
    [ngClass]="{ 'no-content' : !item.content }"
  >
    <mat-expansion-panel-header
      [collapsedHeight]="'40px'"
      [expandedHeight]="'40px'"
      (click)="onSelect(i)"
      [defaultTabIndex]="currentSelectedIndex"
    >
      <mat-panel-title>
        <div class="title">{{ item.title }}</div>
        <button
          (click)="$event.preventDefault(); $event.stopPropagation()"
          mat-icon-button
          [matMenuTriggerFor]="menu"
          class="no-animation-btn icon-dropdown-button"
        >
          <i class="far fa-ellipsis-h"></i>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item>Mark Report As Complete</button>
        </mat-menu>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-panel-description *ngIf="item.content">
      <div class="description-content">
        Show outlier when country tax rate is less than:
      </div>

      <div class="description-body">
        <mat-form-field appearance="outline" class="no-mat-label">
          <mat-label>Country Tax Rate (%)</mat-label>
          <input matInput />
          <mat-icon matSuffix>mode_edit</mat-icon>
        </mat-form-field>
        <button mat-button class="action-button">Update</button>
      </div>
    </mat-panel-description>
  </mat-expansion-panel>
</mat-accordion>

<div class="pagination-note">0 of 19 reports completed.</div>

<!--<ul class="accordion-list">-->
<!--  <li-->
<!--    class="accordion-item"-->
<!--    *ngFor="let item of data; let i = index"-->
<!--    [class.open]="activeIndex === i"-->
<!--    (click)="toggleAccordion(i)"-->
<!--  >-->
<!--    <div class="accordion-header">{{ item.title }}</div>-->
<!--    <div class="accordion-content" *ngIf="item.content">-->
<!--      {{ item.content }}-->
<!--    </div>-->
<!--  </li>-->
<!--</ul>-->
